import {store} from "modules/store";
import {get} from "lodash";

const trkGuid = "da779888-77f9-423c-baa2-1f60dc19b1e5";

export enum EventGUID {
	HOMEPAGE_LOAD = "a8b27bb1-ec5f-42a3-ab9b-1e5577d2c336", // f2p_homepage_load
	ACCOUNT_LOAD = "2ef76c93-5204-40a4-a81e-898ce800c1d7", // f2p_account_load
	HELP_LOAD = "2f0c8a26-66d9-4ef2-a98b-ab107a25a56c", // f2p_help_load

	REGISTRATION_START = "5c677905-e68a-44b1-9184-6a36d531d08a", // f2p_registration_start
	REGISTRATION_COMPLETE = "d3f3dd4d-1244-4fee-b788-2902806b5164", // f2p_registration_complete

	GAMEPLAY_START = "b2ec464a-33ae-48e3-a05d-1dcc59f5a12a", // f2p_gameplay_start
	GAMEPLAY_COMPLETE = "e266e081-a931-43c3-8427-b7f2b5a3e1c0", // f2p_gameplay_complete
	GAMEPLAY_UPDATE_PICKS = "52760a23-10b2-4a11-a951-db87abb2e7af", // f2p_gameplay_update_picks
	GAMEPLAY_SHARE = "7f5d9d28-2cfe-43e8-afbc-7b7b1acba404", // f2p_gameplay_share
	GAMEPLAY_ACTION = "b96db3d3-f662-450b-95a8-1504e00b5e4f", // f2p_gameplay_action

	LEAGUES_LOAD = "b36c4141-b90a-4f88-8e74-13cf6fd01d56", // f2p_leagues_load
	LEAGUES_CREATE_LOAD = "4480780b-224c-4673-aa4f-cb34bbdaef72", // f2p_leagues_create_load
	LEAGUES_CREATE_COMPLETE = "e016ef27-88ec-4dd2-b4a1-87b0392407ad", // f2p_leagues_create_complete
	LEAGUES_JOIN_LOAD = "18b5a417-833b-4a57-8a71-76cb3a55c601", // f2p_leagues_join_load
	LEAGUES_JOIN_COMPLETE = "423c41a2-e7c4-417b-b816-6e4dab02aa85", // f2p_leagues_join_complete
	LEAGUES_CREATE_SHARE_SOCIAL = "20db5f18-75f7-4ad8-a15e-4fdb22abdd90", // f2p_leagues_create_share_social
	LEAGUES_CREATE_SHARE_COPY = "6617d09f-eeb2-4a09-bb78-118192957749", // f2p_leagues_create_share_copy
	LEAGUES_CREATE_SHARE_EMAIL = "d6ba4cb1-ae59-44d0-95e1-9da517d75deb", // f2p_leagues_create_share_email

	NAVIGATION_HOMEPAGE = "3003904c-0fe0-40dc-b492-eb7a7faef7de", // f2p_navigation_homepage
	NAVIGATION_LEAGUES = "db1a16bb-9606-449c-98e1-75efa37f9a11", // f2p_navigation_leagues
	NAVIGATION_TUTORIAL = "283849fe-aed0-4906-9b43-c865b1b40157", // f2p_navigation_tutorial
	NAVIGATION_PRIZES = "a05a6b86-c31d-4382-8475-396e637b0b9d", // f2p_navigation_prizes
	NAVIGATION_RESULTS = "274ddfd2-66c2-4551-a1b2-41a95cbac1db", // f2p_navigation_results

	SPONSOR_CLICK = "335f5d33-7777-4652-a9f7-4073f2429fa8", // f2p_sponsor_click
}

export const createFanHubEvent = (evtGuid: EventGUID) => {
	try {
		const allStore = store.getState();

		const keyIndex = Object.values(EventGUID).findIndex((value) => value === evtGuid);
		const key = Object.keys(EventGUID)[keyIndex];
		console.log(key);
		const clientUserId = String(get(allStore, "user.currentUser.id", null));
		const url = null;
		const d1 = "bracket";
		const d2 = null;
		const d3 = null;
		const cnvValue = null;
		const cnvCurrency = null;
		const orderId = null;

		window.FanHub?.createEvent(evtGuid, trkGuid, url, d1, d2, d3, cnvValue, clientUserId, cnvCurrency, orderId);
	} catch (e) {
		console.error(e);
	}
};

export const createFanHubEventScriptTag = (evtGuid: EventGUID) => {
	const elementName = "script";
	const SCRIPT_ID = "fanhub-tagging";
	document.getElementById(SCRIPT_ID)?.remove();

	const src = `https://tag.fanhub.geniussports.com/js/evt.js`;
	const url = new URL(src);
	const script = document.createElement(elementName);
	const allStore = store.getState();

	const clientUserId = String(get(allStore, "user.currentUser.id", null));

	script.id = SCRIPT_ID;
	script.src = url.toString();
	script.async = true;
	script.setAttribute("data-trkGuid", trkGuid);
	script.setAttribute("data-evtGuid", evtGuid);
	if (clientUserId) {
		script.setAttribute("data-clientUserId", clientUserId);
	}

	const firstJS = document.getElementsByTagName(elementName)[0];
	firstJS.parentNode!.insertBefore(script, firstJS);

	return script;
};

export const createConnextraScriptTag = (src: string) => {
	console.count(src);

	const elementName = "script";
	const SCRIPT_ID = "connextra-tagging";
	document.getElementById(SCRIPT_ID)?.remove();

	const script = document.createElement(elementName);
	script.id = SCRIPT_ID;
	script.src = src;
	script.async = true;
	script.defer = true;

	const firstJS = document.getElementsByTagName(elementName)[0];
	firstJS.parentNode!.insertBefore(script, firstJS);

	return script;
};
